import React, { ChangeEvent } from "react";
import {
  Table, Input, Row, Col, Pagination, Button, Spin, notification, Modal, 
  Popconfirm, Breadcrumb, Upload, Select, Form, Cascader, TreeSelect, 
  FormInstance, Space, Dropdown, Menu, Empty,
  Radio,
} from "antd";
import { connect } from "react-redux";
import Column from "antd/lib/table/Column";
import copy from "copy-to-clipboard";
import { RootStoreModel } from "../../redux/reducers";
import { Unsubscribe } from "redux";
import { Link, RouteComponentProps } from "react-router-dom";
// import { Columns } from "./utils";
import { ColumnModel, BasicStateForListModel } from "../models";
import { RemoveInvalidProps } from "../../utils/common";
import dayjs from 'dayjs';
import { CancelTokenSource, IsCancel } from "../../axios/axios.core";
import {
  getDoc,
  getDocList,
  deleteDoc,
  uploadDoc,
  pushDocument,
  getDocumentGroup
} from "../../axios/api.content";
import { 
  UploadOutlined, PlusOutlined, CheckCircleFilled, StopFilled, DownOutlined, FileDoneOutlined
} from "@ant-design/icons";
import { gaEvent } from "../../withTracker"
import { v4 as uuidv4 } from "uuid";
import { getOrgsOptionsSelector, treeNode } from "@redux/selector";
import { getTagList } from "@axios/api.account";
import { TagProps } from "@axios/models";

import { Translation } from "react-i18next";

interface stateModel extends BasicStateForListModel {
  isModalVisible: boolean;
  isMultiple: boolean;
  title: string;
  file: any;
  fileList: any[];
  status: "Active" | "Disabled";
  search: string;
  id: string;
  appTypeVisible: boolean,
  applyPeople: string
  tags: any[],
  selectId: string,
  maxCount: number,
  docType: string,
  fileUrl: string
}

interface propsModel extends RouteComponentProps<any, any, any> {
  orgOptions: treeNode[],
}

const mapStatetoProps = (state: RootStoreModel) => ({
  orgOptions: getOrgsOptionsSelector(state),
});

class DocListPage extends React.Component<propsModel, stateModel> {
  formRef = React.createRef<FormInstance>();
  constructor(props: propsModel) {
    super(props);
    this.state = {
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      columns: [],
      data: [],
      isModalVisible: false,
      isMultiple: false,
      title: "",
      file: "",
      fileList: [],
      status: "Active",
      search: "",
      id: "",
      appTypeVisible: false,
      applyPeople: "",
      tags: [],
      selectId: "",
      maxCount: 9,
      docType: "Upload",
      fileUrl: ""
    };
  }

  cancelToken = CancelTokenSource();

  componentDidMount() {
    this.getList();
    this.getTasks();
  }

  componentDidUpdate(prevProps: propsModel) {
  }

  componentWillUnmount() {
    this.cancelToken.cancel("cancel axios http request");
  }

  onSearch = () => {
    this.getList(1);
  };
  getTasks = () => {
    getTagList().then((res) => {
      var dat = this.formatOptions(res)
      console.log("formatOptions", dat);
      this.setState({ tags: dat })
    })
  }
  formatOptions = (tags: TagProps[]) => {
    return tags.map(({ id, key, values }) => {
      return {
        value: id,
        label: key,
        children: values.map((item: any) => ({
          value: item.id,
          label: item.value,
        })),
      };
    });
  }
  getList = (
    pageIndex = this.state.pageIndex,
    pageSize = this.state.pageSize
  ) => {
    const { search } = this.state;
    this.setState({ loading: true });
    getDocList({ pageIndex, pageSize, search }).then((res) => {
      this.setState({
        data: res.dataList,
        loading: false,
        pageSize: res.pageSize,
        pageIndex: res.pageIndex,
        totalCount: res.totalCount,
      });
    }, () => {
      this.setState({
        loading: false,
      });
    });
  };

  onDelete = (id: string) => {
    this.setState({ loading: true });
    deleteDoc(id).then(() => {
      notification.success({ message: <Translation>{t => {return t("已删除")}}</Translation> });
      this.setState({ loading: false });
      this.getList(1);
    });
  };

  onOk = () => {
    const { id, title, file, status, fileList, isMultiple } = this.state;
    var count = 0;
    if (fileList.length === 0) {
      return notification.error({message: <Translation>{t => {return t("文档不能为空")}}</Translation>})
    }
    this.setState({ loading: true });
    fileList.forEach((item: any) => {
      uploadDoc({
        id: id,
        title: isMultiple ? item.name.split(".")[0] : title,
        file: item.notChangeFile ? file : item,
        status: status,
        docType: 'Upload'
      }).then(
        () => {
          notification.success({ message: <Translation>{t => {return `[${isMultiple ? item.name : title}] ${t("提交成功")}!`}}</Translation> });
          count++;
          if (count === fileList.length) {
            this.setState({ 
              loading: false, 
              id: "",
              title: "", 
              file: "", 
              fileList: [],
              status: "Active", 
              isModalVisible: false, 
              isMultiple: false 
            });
            this.getList(1);
          }
        }).finally(() => {
          !isMultiple && this.state.loading && this.setState({loading: false});
        })
    });
    // uploadDoc({
    //   id: id,
    //   title: title,
    //   file: file,
    //   status: status,
    // }).then(() => {
    //   notification.success({ message: "提交成功！" });
    //   this.setState({ loading: false, title: "", file: "", status: "Active", isModalVisible: false });
    //   this.getList(1);
    // });
  };

  onSingleOk = () => {
    const { id, title, file, status, fileList, docType, fileUrl, isMultiple } = this.state;
    var count = 0;
    if(docType === "Upload"){
      if (fileList.length === 0) {
        return notification.error({message: <Translation>{t => {return t("文档不能为空")}}</Translation>})
      }
    }
    else
    {
      if(fileUrl === "")
        return notification.error({message: <Translation>{t => {return t("文件链接为空")}}</Translation>})
    }
    this.setState({ loading: true });
    uploadDoc({
      id: id,
      title: title,
      file: fileList[0],
      status: status,
      docType: docType,
      fileUrl: fileUrl
    }).then(() => {
      notification.success({ message: "提交成功！" });
      this.setState({ 
        loading: false, 
        id: "",
        title: "", 
        file: "", 
        fileList: [],
        status: "Active", 
        isModalVisible: false, 
        isMultiple: false 
      });
      this.getList(1);
    });
  };

  uploadFile = (res: any) => {
    console.log(res);
    // const { fileList } = res;
    // this.setState({ file: fileList[0].originFileObj });
    if (this.state.isMultiple) {
      var files: any[] = [];
      res.fileList.forEach((item: any) => {
        files.push(item.originFileObj);
      });
      this.setState({fileList: files});
    }
    else {
      this.setState({fileList: [res.fileList[0].originFileObj]});
    }
  };

  onEdit = (item: any) => {
    const { id, title, status, docType, url } = item;
    this.setState({
      id: id,
      title: title,
      status: status,
      docType: docType,
      fileList: [{name: title, notChangeFile: true}]
    });
    if(docType == "Url")
      this.setState({fileUrl: url});
    this.setState({isModalVisible: true});
  };

  onCancel = () => {
    this.setState({
      isModalVisible: false,
      isMultiple: false,
      id: "",
      title: "",
      file: "",
      docType: "Upload",
      fileUrl: "",
      status: "Active"
    });
  };
  applyGroupOk = () => {
    this.setState({ loading: true })
    this.formRef?.current?.validateFields().then((res) => {
      // if (!res.type) {
      //   this.setState({loading: false})
      //   return notification.warning({message: "未选择适用人群"})
      // }
      var arg: any = {pushType: res.type || 'None'};
      // if (this.state.applyPeople == "Organization") {
      //   arg.organizationIds = [];
      //   arg.organizationIds.push(res.Organization);
      // }
      if (this.state.applyPeople == "Tag") {
        arg.tagValueIds = [];
        res.tags.forEach((item: any) => {
          arg.tagValueIds.push(item.tag[1]);
        });
      }
      pushDocument(this.state.selectId, arg).then(c => {
        notification.success({ message: <Translation>{t => {return t("成功")}}</Translation> })
        this.setState({ loading: false, appTypeVisible: false, applyPeople: "" })
      }, () => {
        this.setState({ loading: false })
        notification.error({ message: <Translation>{t => {return t("失败")}}</Translation> })
      })

    })

  }

  getAppSelfService = (id: string) => {
    this.setState({loading: true});
    getDocumentGroup(id).then(
      res => {
        // 先渲染出模态框
        this.setState({ appTypeVisible: true, selectId: id, applyPeople: res.pushType });
        // 再更新formRef
        this.formRef.current?.setFieldsValue({
          type: res.pushType,
          Organization: res.organizationIds[0],
          tags: res.tags
        });
      },
      () => {
        notification.error({message: <Translation>{t => {return t("获取自助服务失败")}}</Translation>});
      }
    ).finally(
      () => {
        this.setState({loading: false});
      }
    )
  }

  render() {
    const {
      loading,
      data,
      pageSize,
      pageIndex,
      totalCount,
      isModalVisible,
      isMultiple,
      title,
      status,
      search,
      id,
      appTypeVisible,
      applyPeople,
      tags,
      maxCount,
      docType,
      fileUrl
    } = this.state;
    const { orgOptions } = this.props;
    return (
      (<Translation>{t => {
          return (
            (<div>
              <div className="breadcrumbTop py-2">
                <Breadcrumb>
                  <Breadcrumb.Item>{t("内容")}</Breadcrumb.Item>
                  <Breadcrumb.Item>{t("文档")}</Breadcrumb.Item>
                </Breadcrumb>
                <Row style={{padding: "32px 0 11px 0"}}>
                    <Space>
                        <img src="/images/contentdocumentIcon.svg" alt="" />
                        <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("文档")}</span>
                    </Space>
                </Row>
              </div>
              <Spin spinning={false}>
                <Row style={{ width: "100%" }}>
                  <div className="borderBox">
                    <Row className="mb-3">
                      <Col>
                        {t("文档标题")}:
                        <Input
                          placeholder={t("输入文档标题搜索")}
                          style={{ width: "200px", marginLeft: 10 }}
                          value={search}
                          onChange={(e) => this.setState({ search: e.target.value })}
                        ></Input>
                      </Col>

                      <Col offset={1}>
                        <Button type="primary" onClick={() => { this.onSearch(); gaEvent("docs", "onClick", "onSearch") }}>
                          {t("查询")}
                        </Button>
                      </Col>

                    </Row>
                  </div>
                  <div className="borderBox">
                    <Row style={{marginBottom: 8}}>
                      <Col className="ms-auto">
                        {/* <Button
                          type="primary"
                          onClick={() => { this.setState({ isModalVisible: true }); gaEvent("docs", "onClick", "上传文档") }}
                        ><PlusOutlined />
                          上传文档
                        </Button> */}
                        <Space>
                          {/* <Button>{t("新建目录")}</Button> */}
                          <Dropdown
                            trigger={['click']}
                            dropdownRender={() => (
                              <Menu>
                                <Menu.Item key={1} onClick={() => { this.setState({ isModalVisible: true }); gaEvent("docs", "onClick", "上传文档") }}>{t("上传文档")}</Menu.Item>
                                <Menu.Item key={2} onClick={() => { this.setState({ isMultiple: true }); gaEvent("docs", "onClick", "批量上传") }}>{t("批量上传")}</Menu.Item>
                              </Menu>
                            )}
                          >
                            <Button type="primary">{t("上传")} <DownOutlined /></Button>
                          </Dropdown>
                        </Space>
                      </Col>
                    </Row>
                    <Table
                      size="middle"
                      loading={loading}
                      dataSource={data}
                      pagination={false}
                      onChange={(pagination) => { }}
                      rowKey={record => record.id}
                      locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                    >
                      <Column 
                        key="title" 
                        dataIndex="title" 
                        title={t("文档标题")}
                        render={(v) => {
                          return (<>
                            <Space className="space-width-auto">
                              <FileDoneOutlined style={{display: "block"}}/>
                              <span>{v}</span>
                            </Space>
                          </>)
                        }}
                      ></Column>
                      <Column
                        key="url"
                        dataIndex="url"
                        title={t("文档内容")}
                        render={(v) => (
                          (<Button href={v} target="_blank" type="link" size="small">{t("下载")}</Button>)
                          // <Dropdown
                          //   trigger={['click']}
                          //   dropdownRender={() => (
                          //     <Menu>
                          //       <Menu.Item key={1} onClick={() => { 
                          //         copy(v); 
                          //         notification.success({message: t("复制链接成功")})
                          //         gaEvent("docs", "onClick", "复制链接") 
                          //       }}>
                          //         <Button type="text" size="small">{t("复制链接")}</Button>
                          //       </Menu.Item>
                          //       <Menu.Item key={2} onClick={() => { gaEvent("docs", "onClick", "直接下载") }}>
                          //         <Button href={v} type="text" size="small">{t("直接下载")}</Button>
                          //       </Menu.Item>
                          //     </Menu>
                          //   )}
                          //   >
                          //   <Button type="link">{t("查看")} <DownOutlined /></Button>
                          // </Dropdown>
                        )}
                      ></Column>
                      <Column
                        key="status"
                        dataIndex="status"
                        title={t("状态")}
                        render={(v) => (
                          <> 
                            {v=="Active"&&(
                              <span><CheckCircleFilled  style={{color:"#4CB8BE",fontSize:16}}/>&nbsp;&nbsp;{v}</span>
                            )}
                            {v=="Disabled"&&(
                              <span><StopFilled  style={{color:"#C9A063",fontSize:16}}/>&nbsp;&nbsp;{v}</span>
                            )}
                          </>
                        )}
                      ></Column>
                      <Column
                        key="updateTime"
                        dataIndex="updateTime"
                        title={t("更新时间")}
                      // render={(v) => v?.slice(10)}
                      ></Column>

                      <Column
                        key="operation"
                        dataIndex="id"
                        title={t("操作")}
                        render={(v: string, d: any) => {
                          return (
                            <Space size={8}>
                              <Button type="link" size="small" onClick={() => { this.onEdit(d); gaEvent("docs", "onClick", "onEdit") }}>
                                {t("编辑")}
                              </Button>
                              <Popconfirm
                                title={`${t("确认删除文档")} ${d.title}？`}
                                onConfirm={() => this.onDelete(v)}
                                okText={t("确认")}
                                cancelText={t("取消")}
                              >
                                <Button type="link" size="small">
                                  {t("删除")}
                                </Button>
                              </Popconfirm>
                              <Button type="link" size="small" onClick={() => { this.getAppSelfService(v); gaEvent("docs", "onClick", "自助服务") }}>
                                {t("自助服务")}
                              </Button>
                            </Space>
                          );
                        }}
                      ></Column>
                    </Table>
                    <Pagination
                      style={{ textAlign: "right", marginTop: "20px" }}
                      pageSize={pageSize}
                      current={pageIndex}
                      total={totalCount}
                      showTotal={(total, range) =>
                        `${range[0]}-${range[1]} / ${total} ${t("条")}`
                      }
                      onChange={(page, pageSize) => {
                        this.getList(page, pageSize);
                      }}
                      onShowSizeChange={(current, size) => this.getList(current, size)}
                    ></Pagination>
                  </div>
                </Row>
              </Spin>
              <Modal
                confirmLoading={loading}
                maskClosable={false}
                open={appTypeVisible}
                destroyOnClose={false}
                title={t("自助服务")}
                width={"650px"}
                onOk={() => {
                  this.applyGroupOk()
                }}
                onCancel={() => {
                  this.setState({ appTypeVisible: false, applyPeople: "" })
                  this.formRef.current?.resetFields()
                }}
                okText={t("确认")}
                cancelText={t("取消")}
              >
                <Form style={{ width: "90%", marginTop: 36 }}
                  layout="horizontal"
                  ref={this.formRef}
                  // labelCol={{ span: 3 }}
                  initialValues={{ type: "None" }}>
                  {/* <Form.Item label="应用分类" name="status" rules={[{ required: false }]} >
                    <Select>
                      <Select.Option value="1">效率</Select.Option>
                    </Select>

                  </Form.Item> */}
                  <Form.Item label={t("适用人群")} name="type" rules={[{ required: false }]} >
                    <Select allowClear placeholder={t("未选择")} onChange={(e) => {
                      this.setState({ applyPeople: e + "" })
                      this.formRef.current?.setFieldsValue({
                        Organization: [],
                        tags: []
                      })
                    }}>
                      <Select.Option value="None">{t("未选择")}</Select.Option>
                      <Select.Option value="All">{t("全部")}</Select.Option>
                      {/* <Select.Option value="Organization">{t("部门")}</Select.Option> */}
                      <Select.Option value="Tag">{t("设备组")}</Select.Option>
                    </Select>
                  </Form.Item>
                  {/* {applyPeople == "Organization" && (
                    <Form.Item label={t("选择部门")} name="Organization" rules={[{ required: false }]} >
                      <TreeSelect treeData={orgOptions} treeDefaultExpandAll></TreeSelect>
                    </Form.Item>
                  )} */}
                  {applyPeople == "Tag" && (
                    <Form.List name="tags">
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map((field) => (
                            <Form.Item key={field.key} labelCol={{ span: 3 }} label={t("设备组")}>
                              <Row justify="space-between">
                                <Col span="21">
                                  <Form.Item noStyle
                                    {...field}
                                    name={[field.name, "tag"]}
                                    // fieldKey={[field.fieldKey, "tag"]}
                                  >
                                    <Cascader options={tags} />
                                  </Form.Item>
                                </Col>
                                <Col>
                                  <Button type="dashed" onClick={() => { remove(field.name); gaEvent("deviceAdd", "onClick", "remove") }}>-</Button>
                                </Col>
                              </Row>
                            </Form.Item>
                          ))}
                          <Form.Item wrapperCol={{ offset: 3 }}>
                            <Button type="dashed" onClick={() => { add(); gaEvent("deviceAdd", "onClick", "add") }} block>
                              {t("添加设备组")}
                            </Button>
                          </Form.Item>
                        </>
                      )}
                    </Form.List>
                  )}
                </Form>
              </Modal>
              <Modal
                maskClosable={false}
                title={id ? t("编辑文档") : t("上传文档")}
                destroyOnClose={true}
                confirmLoading={loading}
                open={isModalVisible}
                onOk={() => this.onSingleOk()}
                onCancel={() => this.onCancel()}
                okText={t("确认")}
                cancelText={t("取消")}
              >
                <Row gutter={24}>
                  <Col span={24}>
                    <label htmlFor="">{t("文档标题")}</label>
                    <div>
                      <Input
                        placeholder={t("文档标题")}
                        value={title}
                        onChange={(e) => this.setState({ title: e.target.value })}
                      ></Input>
                    </div>
                  </Col>
                  <Col span={24} style={{paddingTop:'20px'}}>
                    <Radio.Group value={docType} onChange={(e)=>{this.setState({docType:e.target.value});}}>
                      <Radio value="Upload">上传文件</Radio>
                      <Radio value="Url">文件链接</Radio>
                    </Radio.Group>
                  </Col>
                  {docType == "Upload" && <Col span={24} className="mt-3">
                    {/* <label htmlFor="">{t("文档")}</label> */}
                    <div>
                      <Upload
                        accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.jpg,.png,.epub,.key,.numbers,.pages,.ibooks,.mp3,.mp4,.acc"
                        listType="text"
                        showUploadList={true}
                        beforeUpload={() => {
                          return false;
                        }}
                        maxCount={1}
                        onChange={this.uploadFile}
                      >
                        <Button icon={<UploadOutlined />}>+ {t("点击上传")} </Button>
                      </Upload>
                    </div>
                  </Col>}
                  {docType == "Url" && <Col span={24} className="mt-3">
                    <div>
                      <Input
                        placeholder={t("文件链接")}
                        value={fileUrl}
                        onChange={(e) => this.setState({ fileUrl: e.target.value })}
                      ></Input>
                    </div>
                  </Col>}
                  <Col span={24} className="mt-3">
                    <label htmlFor="">{t("状态")}</label>
                    <div>
                      <Select
                        value={status}
                        onChange={(v) => this.setState({ status: v as any })}
                      >
                        <Select.Option value="Active"> {t("正常")}</Select.Option>
                        <Select.Option value="Disabled"> {t("禁用")}</Select.Option>
                      </Select>
                    </div>
                  </Col>
                </Row>
              </Modal>
              <Modal
                maskClosable={false}
                title={t("批量上传")}
                destroyOnClose={true}
                confirmLoading={loading}
                open={isMultiple}
                onOk={() => this.onOk()}
                onCancel={() => this.onCancel()}
                okText={t("确认")}
                cancelText={t("取消")}
              >
                <Row gutter={24}>
                  <Col span={24}>
                    <label htmlFor="">{t("文档")}</label>
                    <div>
                      <Upload
                        accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.jpg,.png,.epub,.key,.numbers,.pages,.ibooks,.mp3,.mp4,.acc"
                        listType="text"
                        showUploadList={true}
                        beforeUpload={() => { return false; }}
                        maxCount={maxCount}
                        onChange={this.uploadFile}
                        multiple
                      >
                        <Button icon={<UploadOutlined />}>{t("点击上传")} </Button>
                      </Upload>
                    </div>
                  </Col>
                </Row>
              </Modal>
            </div>)
          );
        }}</Translation>)
    );
  }
}

export default connect(mapStatetoProps, {})(DocListPage);
